import { Alert, AlertTitle } from '@mui/material';
import React from 'react';

export interface MultiplexSelectionAlertProps {
  severity: 'error' | 'info';
  title: string;
  message: string;
}

export const MultiplexSelectionAlert: React.FC<MultiplexSelectionAlertProps> = ({ severity, title, message }) => {
  return (
    <Alert severity={severity} sx={{ width: '100%' }}>
      <AlertTitle>{title}</AlertTitle>
      {message}
    </Alert>
  );
};
